import '@hotmart/cosmos/dist/content-loader'
import clsx from 'clsx'

type ContentLoaderProps = {
  className?: string
  slot?: string
}

const ContentLoader = ({ className }: ContentLoaderProps) => {
  return <hot-content-loader class={clsx('content-loader', className)}></hot-content-loader>
}

export default ContentLoader
